import { useTranslation } from 'react-i18next';
import {
  ETeamComparisonRating,
  ETeamComparisonRepresentativeness,
  ETeamComparisonRiskLevel,
} from '../constans/report';
import { THEME as theme } from '../styles/theme';

export const useGroupComparison = () => {
  const { t } = useTranslation();

  const getRepresentativenessColor = (representativeness: ETeamComparisonRepresentativeness) => {
    switch (representativeness) {
      case ETeamComparisonRepresentativeness.poor:
        return theme.colors.accent.red[100];
      case ETeamComparisonRepresentativeness.acceptable:
        return theme.colors.accent.blue[100];
      case ETeamComparisonRepresentativeness.good:
        return theme.colors.accent.green[100];
      default:
        return theme.colors.accent.green[100];
    }
  };

  const getRiskColor = (risk?: ETeamComparisonRiskLevel) => {
    switch (risk) {
      case ETeamComparisonRiskLevel.low:
        return theme.colors.accent.green[100];
      case ETeamComparisonRiskLevel.potential:
        return theme.colors.accent.violet[100];
      case ETeamComparisonRiskLevel.high:
        return theme.colors.accent.red[100];
      default:
        return theme.colors.accent.red[100];
    }
  };
  const getRatingColor = (rating?: ETeamComparisonRating) => {
    switch (rating) {
      case ETeamComparisonRating.strong:
        return theme.colors.accent.green[100];
      case ETeamComparisonRating.normal:
        return theme.colors.accent.blue[100];
      case ETeamComparisonRating.weak:
        return theme.colors.accent.red[100];
      default:
        return theme.colors.accent.green[100];
    }
  };

  const riskTypesArr = [
    {
      id: 'low',
      name: t('report.groupComparison.riskLevel.low'),
    },
    {
      id: 'potential',
      name: t('report.groupComparison.riskLevel.potential'),
    },
    {
      id: 'high',
      name: t('report.groupComparison.riskLevel.high'),
    },
  ];

  const sortTypesArr = [
    {
      id: 'fl1',
      name: t('report.groupComparison.sortTypes.teamName'),
      value: 'team',
    },
    {
      id: 'fl2',
      name: t('report.groupComparison.sortTypes.responseRate'),
      value: 'responseRate',
    },
  ];

  return {
    getRatingColor,
    getRepresentativenessColor,
    getRiskColor,
    riskTypesArr,
    sortTypesArr,
  };
};
